import { ProductResponseSingle, ProductResponseMulti } from './responses';

export interface ProductInterface {
  id: number;
  name: string;
  description: string;
  tags: string[];
  is_available: boolean;
  created_at: Date;
  updated_at: Date;
  image_url: string;
  image_original_name: string;
}

export interface UnsavedProduct {
  name: string;
  description: string;
  tags: string[];
  is_available: boolean;
  image: File;
}

export interface ProductWithImage extends ProductInterface {
  image: File | null;
}

export class Product implements ProductInterface {
  public static fromResponseSingle(response: ProductResponseSingle): Product {
    const { tags, ...rest } = response.data.product;
    const product: ProductInterface = Object.assign({ tags: [] }, rest);

    if (tags != null) {
      product.tags = tags.split(',');
    }

    return new Product(
      product.id,
      product.name,
      product.description,
      product.tags,
      product.is_available,
      product.created_at,
      product.updated_at,
      product.image_url,
      product.image_original_name,
    );
  }

  public static fromResponseMulti(response: ProductResponseMulti): Product[] {
    return response.data.products.map((responseProduct) => {
      const { tags, ...rest } = responseProduct;
      const product: ProductInterface = Object.assign({ tags: [] }, rest);

      if (tags != null) {
        product.tags = tags.split(',');
      }

      return new Product(
        product.id,
        product.name,
        product.description,
        product.tags,
        product.is_available,
        product.created_at,
        product.updated_at,
        product.image_url,
        product.image_original_name,
      );
    });
  }

  constructor(
    public id: number,
    public name: string,
    public description: string,
    public tags: string[],
    public is_available: boolean,        // tslint:disable-line variable-name
    public created_at: Date,             // tslint:disable-line variable-name
    public updated_at: Date,             // tslint:disable-line variable-name
    public image_url: string,            // tslint:disable-line variable-name
    public image_original_name: string,  // tslint:disable-line variable-name
  ) { }

}
